import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';


export class MinValueValidatorDirective implements Validator {

	 public minValue: number = 0;

	public validate(control: AbstractControl): {[key: string]: any} {
		let input = control.value;
		let isValid = input >= this.minValue;
		if (!isValid) {
			return { minValue: true };
		}

		return null;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/directives/min-value-validator.directive.ts